const MONTH = /^(\d{4})-(0[1-9]|1[0-2])$/;

/**
 * Inclusive ISO date bounds of a `YYYY-MM` month, for the expense list's
 * `startDate`/`endDate` filters. Computed with UTC arithmetic so the
 * result does not depend on the device time zone.
 */
export function monthBounds(month: string): {
  startDate: string;
  endDate: string;
} {
  const match = MONTH.exec(month);
  if (!match) {
    throw new RangeError(`Not a YYYY-MM month: ${month}`);
  }
  const year = Number(match[1]);
  const monthIndex = Number(match[2]);
  const lastDay = new Date(Date.UTC(year, monthIndex, 0)).getUTCDate();
  return {
    startDate: `${month}-01`,
    endDate: `${month}-${String(lastDay).padStart(2, '0')}`,
  };
}
